/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class SelectOperationPageModel {
      selectedOperationType: string = DvsAddHostWizardConstants.operationType.ADD_HOST;
   }
}